import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const SearchResults = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const searchQuery = queryParams.get("q");

    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const itemsPerPage = 9;

    useEffect(() => {
        if (searchQuery) {
            setLoading(true);
            fetch(`https://jiimpex.com/new_project/ji-impex/search-products.php?query=${encodeURIComponent(searchQuery)}&page=${currentPage}&limit=${itemsPerPage}`)
                .then((response) => response.json())
                .then((data) => {
                    if (data.error) {
                        setError(data.error);
                        setResults([]);
                    } else if (data.message) {
                        setError(data.message);
                        setResults([]);
                    } else {
                        setResults(data.products || []);
                        setTotalPages(data.total_pages || 1);
                    }
                })
                .catch(() => setError("Failed to fetch search results. Please try again."))
                .finally(() => setLoading(false));
        }
    }, [searchQuery, currentPage]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (
        <div className="container py-5">
            <h1 className="text-center mb-4">Search Results for "{searchQuery}"</h1>

            {loading && <p className="text-center">Loading...</p>}
            {error && <p className="text-center text-danger">{error}</p>}

            <div className="row g-4">
                {results.map((service, index) => (
                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay={`${0.1 + index * 0.2}s`} key={service.id}>
                        <div className="service-item bg-light overflow-hidden h-100">
                            <img className="img-fluid" src={service.product_image} alt={service.name}/>
                            <div className="service-text position-relative text-center h-100 p-4">
                                <h5 className="mb-3">{service.name}</h5>
                                <p dangerouslySetInnerHTML={{ __html: service.description }}></p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
                <div className="pagination d-flex justify-content-center mt-4">
                    {[...Array(totalPages)].map((_, index) => (
                        <button
                            key={index + 1}
                            onClick={() => handlePageChange(index + 1)}
                            className={`btn ${currentPage === index + 1 ? 'btn-primary' : 'btn-outline-primary'} mx-1`}
                        >
                            {index + 1}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default SearchResults;
